import { Navigate, Route, Routes } from 'react-router-dom';

import { CausesFollowingModal } from './CausesFollowing/CausesFollowing';
import { OnboardingIntentModal } from './OnboardingIntent/OnboardingIntentModal';
import { Welcome } from './WelcomeCarousel/Welcome';
import { YourPersonalizedStart } from './YourPersonalizedStart';
import { Cause } from './causes/Cause/Cause';
import { Causes } from './causes/Causes';

const OnboardingRoutes = () => {
  return (
    <Routes>
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/your-personalized-start" element={<YourPersonalizedStart />} />
      <Route path="/intent" element={<OnboardingIntentModal />} />
      <Route path="/causes" element={<Causes />} />
      <Route path="/causes/:causeId" element={<Cause />} />
      <Route path="/causes-following" element={<CausesFollowingModal />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export { OnboardingRoutes };
